<app-page-breadcrumb pageTitle="Productos"></app-page-breadcrumb>

<div class="space-y-4">
  <!-- Compact Controls Section -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <!-- Left side -->
    <div class="flex items-center gap-1.5">
      <div
        class="flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
      >
        <button
          type="button"
          (click)="AllProducts('todos')"
          class="px-3 py-1.5 text-sm font-medium transition-colors"
          [ngClass]="
            filtroOwner === 'todos'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'
          "
        >
          Todos
        </button>

        <button
          type="button"
          (click)="AllProducts('conInventario')"
          class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
          [ngClass]="
            filtroOwner === 'conInventario'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'
          "
        >
          Con Inventario
        </button>

        <button
          type="button"
          (click)="AllProducts('sinInventario')"
          class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
          [ngClass]="
            filtroOwner === 'sinInventario'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'
          "
        >
          Sin Inventario
        </button>

        <button
          type="button"
          (click)="AllProducts('servicios')"
          class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
          [ngClass]="
            filtroOwner === 'servicios'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'
          "
        >
          Servicios
        </button>

        <!-- Inc 53: subtipos de servicio -->
        <button
          type="button"
          (click)="AllProducts('recursos')"
          class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
          [ngClass]="
            filtroOwner === 'recursos'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'
          "
        >
          Recursos
        </button>

        <button
          type="button"
          (click)="AllProducts('consultoria')"
          class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
          [ngClass]="
            filtroOwner === 'consultoria'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'
          "
        >
          Consultoría
        </button>
        <button
          type="button"
          (click)="filterArchived()"
          class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
          [ngClass]="
            filtroStatus === 'archived'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'
          "
        >
          Archivados
        </button>
      </div>
    </div>

    <!-- Right side - Action buttons -->
    <div class="flex items-center gap-1.5">
      <!-- Selector de ordenamiento -->
      <select
        [(ngModel)]="sortBy"
        (ngModelChange)="onSortChange()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 focus:ring-2 focus:ring-brand-500 focus:border-transparent"
      >
        <option value="relevance">Relevancia</option>
        <option value="name_asc">Nombre (A-Z)</option>
        <option value="name_desc">Nombre (Z-A)</option>
        <option value="price_asc">Precio (menor a mayor)</option>
        <option value="price_desc">Precio (mayor a menor)</option>
        <option value="updatedAt_desc">Más recientes</option>
        <option value="createdAt_asc">Más antiguos</option>
        <option value="popularity_desc">Más populares</option>
        <option value="popularity_asc">Menos populares</option>
      </select>

      <button
        type="button"
        (click)="toggleFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
          ></path>
        </svg>
        {{ showFilters ? 'Ocultar' : 'Filtros' }}
      </button>
      <!-- View toggle -->
      <div
        class="flex items-center rounded-lg border border-gray-300 dark:border-gray-600 overflow-hidden"
      >
        <button
          type="button"
          (click)="setViewMode('table')"
          class="px-3 py-1.5 text-sm font-medium transition-colors flex items-center gap-1.5"
          [ngClass]="
            viewMode === 'table'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'
          "
        >
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
          Tabla
        </button>
        <button
          type="button"
          (click)="setViewMode('grid')"
          class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-300 dark:border-gray-600 flex items-center gap-1.5"
          [ngClass]="
            viewMode === 'grid'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'
          "
        >
          <svg
            class="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
            />
          </svg>
          Cuadrícula
        </button>
      </div>
      <button
        type="button"
        *appHasPermission="'products:create'"
        (click)="nuevoProducto()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 4v16m8-8H4"
          ></path>
        </svg>
        Nuevo Producto
      </button>
    </div>
  </div>

  <!-- Compact Filters Panel -->
  @if (showFilters) {
    <div
      class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3"
    >
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <!-- Busqueda por nombre -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Buscar por nombre
          </label>
          <input
            type="text"
            [(ngModel)]="filtroNombre"
            (ngModelChange)="buscar()"
            placeholder="Nombre del producto..."
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Busqueda por SKU -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Buscar por SKU
          </label>
          <input
            type="text"
            [(ngModel)]="filtroSku"
            (ngModelChange)="buscar()"
            placeholder="SKU del producto..."
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Filtro Categoria -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Categoría
          </label>
          <select
            [(ngModel)]="filtroCategoria"
            (ngModelChange)="buscar()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todas las categorías</option>
            @for (cat of categorias; track cat.id) {
              <option [ngValue]="cat.id">{{ cat.name }}</option>
            }
          </select>
        </div>

        <!-- Filtro Estado -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Estado
          </label>
          <select
            [(ngModel)]="filtroStatus"
            (ngModelChange)="buscar()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todos</option>
            <option [ngValue]="'active'">Activo</option>
            <option [ngValue]="'draft'">Borrador</option>
            <option [ngValue]="'discontinued'">Descontinuado</option>
            <option [ngValue]="'archived'">Archivado</option>
          </select>
        </div>

        <!-- Precio minimo -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Precio mínimo
          </label>
          <input
            type="number"
            [(ngModel)]="filtroMinPrecio"
            (ngModelChange)="buscar()"
            placeholder="0.00"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Precio maximo -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Precio máximo
          </label>
          <input
            type="number"
            [(ngModel)]="filtroMaxPrecio"
            (ngModelChange)="buscar()"
            placeholder="999999.99"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Ciclo de facturación -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Ciclo de facturación
          </label>
          <select
            [(ngModel)]="filtroBillingCycle"
            (ngModelChange)="buscar()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todos</option>
            <option value="monthly">Mensual</option>
            <option value="quarterly">Trimestral</option>
            <option value="yearly">Anual</option>
            <option value="one-time">Una sola vez</option>
          </select>
        </div>

        <!-- Checkboxes adicionales -->
        <div class="flex flex-col gap-2 justify-center">
          <label class="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              [checked]="filtroHasVariants === true"
              (change)="
                filtroHasVariants = $any($event.target).checked
                  ? true
                  : undefined;
                buscar()
              "
              class="h-3.5 w-3.5 rounded border-gray-300 text-brand-500 dark:border-gray-600 dark:bg-gray-800"
            />
            <span class="text-xs text-gray-700 dark:text-gray-300"
              >Con variantes</span
            >
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              [checked]="filtroUsesTierPricing === true"
              (change)="
                filtroUsesTierPricing = $any($event.target).checked
                  ? true
                  : undefined;
                buscar()
              "
              class="h-3.5 w-3.5 rounded border-gray-300 text-brand-500 dark:border-gray-600 dark:bg-gray-800"
            />
            <span class="text-xs text-gray-700 dark:text-gray-300"
              >Precio escalonado</span
            >
          </label>
        </div>

        <!-- Boton Limpiar Filtros -->
        <div class="flex items-end">
          <button
            type="button"
            (click)="limpiarFiltro()"
            class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
          >
            Limpiar Filtros
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Loading -->
  @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div
        class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"
      ></div>
      <span class="ml-3 text-gray-500 dark:text-gray-400"
        >Cargando productos...</span
      >
    </div>
  }

  <!-- Error -->
  @if (error) {
    <div
      class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20"
    >
      <div class="flex items-center gap-3">
        <svg
          class="w-5 h-5 text-error-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    </div>
  }

  <!-- Tabla de productos -->
  @if (!loading && !error && viewMode === 'table') {
    <div
      class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/3"
    >
      <div class="max-w-full overflow-x-auto custom-scrollbar">
        <table class="min-w-full">
          <!-- Table Header -->
          <thead class="border-b border-gray-100 dark:border-white/5">
            <tr>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Nombre
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                SKU
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Precio
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Tipo
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Categoría
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Estado
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400"
              >
                Acciones
              </th>
            </tr>
          </thead>

          <!-- Table Body -->
          <tbody class="divide-y divide-gray-100 dark:divide-white/5">
            @if (productos.length === 0) {
              <tr>
                <td
                  colspan="7"
                  class="px-5 py-8 text-center"
                >
                  <div
                    class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400"
                  >
                    <svg
                      class="w-12 h-12"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1"
                        d="M3 7a2 2 0 012-2h4l2 3h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7zm2 0v11h14V10h-6.586L10.586 7H5z"
                      ></path>
                    </svg>
                    <span>No hay productos registrados</span>
                  </div>
                </td>
              </tr>
            }

            @for (producto of productos; track producto.id) {
              <tr [class.opacity-60]="!producto.isActive">
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  <span
                    class="block font-medium text-gray-800 dark:text-white/90"
                  >
                    {{ producto.name }}
                  </span>
                  @if (producto.description) {
                    <span
                      class="block text-xs text-gray-500 dark:text-gray-400 truncate max-w-xs"
                    >
                      {{ producto.description }}
                    </span>
                  }
                  <div class="flex items-center gap-1 mt-1">
                    @if (producto.hasVariants) {
                      <span
                        class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300"
                        >Variantes</span
                      >
                    }
                    @if (producto.usesTierPricing) {
                      <span
                        class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300"
                        >Escalonado</span
                      >
                    }
                  </div>
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  <span
                    class="font-mono text-xs text-gray-600 dark:text-gray-300"
                    >{{ producto.sku }}</span
                  >
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  <div class="font-semibold text-gray-800 dark:text-white/90">
                    @if (tienePromoActiva(producto)) {
                      <p>
                        {{
                          formatPrecio(
                            producto.promoPrice,
                            producto.prefix,
                            producto.currencyCode
                          )
                        }}
                      </p>
                    }
                    <p
                      [class.line-through]="tienePromoActiva(producto)"
                      [class.text-xs]="tienePromoActiva(producto)"
                    >
                      {{
                        formatPrecio(
                          producto.price,
                          producto.prefix,
                          producto.currencyCode
                        )
                      }}
                    </p>
                  </div>
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  <app-badge [color]="'info'">
                    {{ getTipoLabel(producto) }}
                  </app-badge>
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  {{ getCategoryName(producto) }}
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  <app-badge [color]="getActiveColor(producto)">
                    {{ getActiveLabel(producto) }}
                  </app-badge>
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400"
                >
                  <div class="flex items-center justify-center gap-2">
                    <button
                      (click)="verDetalle(producto)"
                      class="rounded-lg p-2 hover:bg-brand-50 hover:text-brand-600 dark:hover:bg-brand-900/20 dark:hover:text-brand-400 transition-colors"
                      title="Ver detalle"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        ></path>
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        ></path>
                      </svg>
                    </button>
                    @if (
                      producto.status === 'draft' ||
                      producto.status === 'archived'
                    ) {
                      <button
                        (click)="changeProductStatus(producto, 'active')"
                        *appHasPermission="'products:edit'"
                        title="Activar"
                        class="p-2 rounded-lg hover:text-success-600 hover:bg-success-50 dark:hover:bg-success-900/20"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      </button>
                    }
                    @if (producto.status === 'active') {
                      <button
                        (click)="changeProductStatus(producto, 'discontinued')"
                        *appHasPermission="'deals:edit'"
                        title="Descontinuar"
                        class="rounded-lg p-2 hover:bg-red-100 dark:hover:bg-red-900/20 hover:text-red-600 dark:hover:text-red-400 transition-colors"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                          />
                        </svg>
                      </button>
                    }
                    <button
                      (click)="editarProducto(producto)"
                      *appHasPermission="'products:edit'"
                      class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/5 transition-colors"
                      title="Editar"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        ></path>
                      </svg>
                    </button>
                    <button
                      (click)="eliminarProducto(producto)"
                      *appHasPermission="'products:delete'"
                      class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors"
                      title="Eliminar"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        ></path>
                      </svg>
                    </button>
                    @if (producto.status !== 'archived') {
                      <button
                        (click)="changeProductStatus(producto, 'archived')"
                        *appHasPermission="'products:edit'"
                        title="Archivar"
                        class="rounded-lg p-2 hover:bg-orange-100 dark:hover:bg-orange-900/20 hover:text-orange-600 dark:hover:text-orange-400 transition-colors"
                      >
                        <svg
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          class="w-4 h-4"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                          ></path>
                        </svg>
                      </button>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Paginación -->
      @if (globalTotalPages >= 1) {
        <div
          class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4"
        >
          <div class="flex items-center justify-between gap-4 flex-wrap">
            <div class="flex items-center gap-2">
              <span class="text-sm text-gray-500 dark:text-gray-400"
                >{{ globalTotalElements }} registros</span
              >
              <select
                [ngModel]="pageSize"
                (ngModelChange)="changePageSize($event)"
                class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
              >
                @for (opt of PAGE_SIZE_OPTIONS; track opt) {
                  <option [value]="opt">{{ opt }}</option>
                }
              </select>
            </div>
            <div class="flex items-center gap-2">
              <button
                type="button"
                (click)="cambiarPagina(globalPage - 1)"
                [disabled]="!hasPrevPage"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
              >
                Anterior
              </button>
              <div class="flex items-center gap-1.5">
                <span class="text-sm text-gray-500 dark:text-gray-400"
                  >Página</span
                >
                <select
                  [ngModel]="pageDisplay"
                  (ngModelChange)="cambiarPagina($event - 1)"
                  class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
                >
                  @for (p of pagesArray; track p) {
                    <option [value]="p">{{ p }}</option>
                  }
                </select>
                <span class="text-sm text-gray-500 dark:text-gray-400"
                  >de {{ globalTotalPages }}</span
                >
              </div>
              <button
                type="button"
                (click)="cambiarPagina(globalPage + 1)"
                [disabled]="!hasNextPage"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
              >
                Siguiente
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Vista Cuadrícula -->
  @if (!loading && !error && viewMode === 'grid') {
    <div class="grid-container">
      <div
        class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 p-4"
      >
        @if (productos.length === 0) {
          <div
            class="col-span-full flex flex-col items-center justify-center gap-2 py-12 text-gray-500 dark:text-gray-400"
          >
            <svg
              class="w-16 h-16"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1"
                d="M3 7a2 2 0 012-2h4l2 3h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7zm2 0v11h14V10h-6.586L10.586 7H5z"
              ></path>
            </svg>
            <span class="text-sm font-medium"
              >No hay productos registrados</span
            >
          </div>
        }

        @for (producto of productos; track producto.id) {
          <div
            class="product-card group"
            [class.opacity-60]="!producto.isActive"
          >
            <div
              class="relative aspect-square bg-gray-100 dark:bg-gray-800 rounded-xl overflow-hidden"
            >
              @if (producto.imageUrl) {
                <img
                  [src]="producto.imageUrl"
                  [alt]="producto.name"
                  class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
              } @else {
                <div
                  class="w-full h-full flex items-center justify-center text-gray-400"
                >
                  <svg
                    class="w-12 h-12"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1"
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    ></path>
                  </svg>
                </div>
              }
              <div class="absolute top-2 left-2 flex gap-1">
                @if (producto.hasVariants) {
                  <span
                    class="px-2 py-1 rounded-lg text-[10px] font-medium bg-purple-100 text-purple-700 dark:bg-purple-900/80 dark:text-purple-200 shadow-sm"
                    >Variantes</span
                  >
                }
                @if (producto.usesTierPricing) {
                  <span
                    class="px-2 py-1 rounded-lg text-[10px] font-medium bg-amber-100 text-amber-700 dark:bg-amber-900/80 dark:text-amber-200 shadow-sm"
                    >Escalonado</span
                  >
                }
              </div>
              <div class="absolute top-2 right-2 flex gap-1">
                @if (tienePromoActiva(producto)) {
                  <span
                    class="px-2 py-1 rounded-lg text-[10px] font-medium bg-success-100 text-success-700 dark:bg-success-900/80 dark:text-success-200 shadow-sm"
                    >Promoción</span
                  >
                }
              </div>
              @if (!producto.isActive) {
                <div
                  class="absolute inset-0 bg-black/50 flex items-center justify-center backdrop-blur-sm"
                >
                  <span
                    class="px-2 py-1 rounded-lg text-xs font-bold bg-red-500 text-white shadow-lg"
                    >INACTIVO</span
                  >
                </div>
              }
            </div>

            <div class="product-info">
              <div>
                <h3 class="product-name line-clamp-2">{{ producto.name }}</h3>
                @if (producto.description) {
                  <p class="product-description">{{ producto.description }}</p>
                }
              </div>
              <div class="product-meta">
                <span class="product-sku">{{ producto.sku }}</span>
                <app-badge
                  [color]="'info'"
                  class="text-[10px]!"
                  >{{ getTipoLabel(producto) }}</app-badge
                >
              </div>
              <div
                class="text-xs text-gray-500 dark:text-gray-400 truncate mt-1"
              >
                {{ getCategoryName(producto) }}
              </div>
              <div class="product-price">
                @if (tienePromoActiva(producto)) {
                  <span>
                    {{
                      formatPrecio(
                        producto.promoPrice,
                        producto.prefix,
                        producto.currencyCode
                      )
                    }}
                  </span>
                }
                <span
                  [class.line-through]="tienePromoActiva(producto)"
                  [class.text-sm]="tienePromoActiva(producto)"
                >
                  {{
                    formatPrecio(
                      producto.price,
                      producto.prefix,
                      producto.currencyCode
                    )
                  }}
                </span>
              </div>
              <div class="product-actions">
                <span
                  [class]="
                    'status-badge ' +
                    (producto.isActive ? 'status-active' : 'status-inactive')
                  "
                  >{{ getActiveLabel(producto) }}</span
                >
                <div class="action-buttons">
                  <button
                    (click)="verDetalle(producto)"
                    class="action-btn btn-view"
                    title="Ver detalle"
                  >
                    <svg
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      ></path>
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    (click)="editarProducto(producto)"
                    *appHasPermission="'products:edit'"
                    class="action-btn btn-edit"
                    title="Editar"
                  >
                    <svg
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    (click)="eliminarProducto(producto)"
                    *appHasPermission="'products:delete'"
                    class="action-btn btn-delete"
                    title="Eliminar"
                  >
                    <svg
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>

      @if (globalTotalPages >= 1) {
        <div
          class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4"
        >
          <div class="flex items-center justify-between gap-4 flex-wrap">
            <span class="text-sm text-gray-500 dark:text-gray-400"
              >{{ globalTotalElements }} registros</span
            >
            <div class="flex items-center gap-2">
              <button
                type="button"
                (click)="cambiarPagina(globalPage - 1)"
                [disabled]="!hasPrevPage"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed"
              >
                Anterior
              </button>
              <span class="text-sm text-gray-500 dark:text-gray-400"
                >{{ pageDisplay }} / {{ globalTotalPages }}</span
              >
              <button
                type="button"
                (click)="cambiarPagina(globalPage + 1)"
                [disabled]="!hasNextPage"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed"
              >
                Siguiente
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<!-- Modal de detalle -->
<app-producto-detail-modal
  [isOpen]="showDetailModal"
  [producto]="selectedProducto"
  [categorias]="categorias"
  (close)="cerrarModal()"
>
</app-producto-detail-modal>
